<app-card *ngIf="!registro?.contestacaoId">
  <div text>
    <div class="row">
      <div class="col-auto mt-n2" style="max-width: 2.5rem">
        <mat-icon class="registro-icon">{{ getRegistroIcon() }}</mat-icon>
      </div>
      <bdg-info-label class="col mt-n2" label="{{ title }}">{{ titleRef }}</bdg-info-label>
      <bdg-info-label
        *ngIf="canShowDataRegistro"
        class="col-12 col-sm-6 col-lg mt-3 mt-sm-n2"
        label="Data do registro"
        >{{ registro?.ocorrencia?.dataRegistro | date: 'dd/MM/yy' }}</bdg-info-label
      >

      <bdg-info-label
        *ngIf="!ocorrenciaRelacionadaDesc"
        class="col-12 col-sm-6 col-lg mt-3 mt-lg-n2"
        label="{{ getPeriodoTitle(registro?.ocorrencia) }}"
      >
        {{ getPeriodoValue(registro?.ocorrencia) }}</bdg-info-label
      >

      <bdg-info-label
        *ngIf="ocorrenciaRelacionadaDesc"
        class="col-12 col-sm-6 col-lg mt-3 mt-lg-n2"
        label="Ocorrência relacionada"
      >
        {{ ocorrenciaRelacionadaDesc }}</bdg-info-label
      >

      <div class="d-flex col-12 col-sm-6 col-lg mt-3 mt-lg-n2" *ngIf="diasDesc">
        <bdg-info-label [label]="diasDesc"> {{ diasValue }}</bdg-info-label>
        <mat-icon *ngIf="diasIconTooltipText" [matTooltip]="diasIconTooltipText" class="dias-icon-tooltip mt-n1"
          >info</mat-icon
        >
      </div>

      <a *ngIf="canDelete" href="javascript:void(0)" (click)="onDeleteClicked()">
        <div class="col-auto mt-n2 mr-2" style="max-width: 2.5rem">
          <mat-icon class="delete-icon">delete</mat-icon>
        </div>
      </a>
    </div>
    <bdg-label *ngIf="registro?.ocorrencia?.justificativa" class="d-flex mt-3 align-items-center" type="body-1">
      {{ registro?.ocorrencia?.justificativa }}
    </bdg-label>
    <div class="mb-n3">
      <div *ngIf="isAlteracaoSituacao" class="mt-2">
        <bdg-tag>Alteração de situação</bdg-tag>
      </div>
      <bdg-label
        *ngIf="!isRegistradoAutomaticamente && registro?.ocorrencia?.nomeAutor"
        class="d-flex mt-2"
        type="caption"
      >
        {{ 'Registrado por ' + registro.ocorrencia.nomeAutor }}
      </bdg-label>
      <bdg-label *ngIf="isRegistradoAutomaticamente" class="d-flex mt-2" type="caption">
        <em>Registrado automaticamente</em>
      </bdg-label>
    </div>
  </div>
</app-card>
<mat-card *ngIf="registro?.contestacaoId">
  <div class="row mb-3">
    <div class="col-auto" style="max-width: 2.5rem">
      <mat-icon class="avaliacao-icon">local_atm</mat-icon>
    </div>
    <bdg-info-label class="col" label="Contestação de pagamento">{{
      'Ref. ' + (registro.referencia | protocolo: 3)
    }}</bdg-info-label>
    <bdg-info-label class="col-12 col-sm-6 col-lg mt-3 mt-sm-0" label="Nº de protocolo">
      {{ registro.contestacaoId | protocolo: 8 }}
    </bdg-info-label>
    <bdg-info-label class="col-12 col-sm-6 col-lg mt-3 mt-sm-2 mt-lg-0" label="Dias compensados">
      {{ registro.numeroDias + ' dias' }}
    </bdg-info-label>
    <bdg-info-label
      class="col-12 col-sm-6 col-lg mt-3 mt-sm-2 mt-lg-0"
      label="Ocorrência relacionada"
      [truncate]="false"
    >
      {{ descricaoOcorrenciaRelacionada }}
    </bdg-info-label>
  </div>
</mat-card>
